var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdoCheckbox"},_vm._l((_vm.checkboxDataList),function(item,index){return _c('div',{key:index},[_c('el-checkbox',{attrs:{"label":item.productName,"border":""},model:{value:(item.chooseFlag),callback:function ($$v) {_vm.$set(item, "chooseFlag", $$v)},expression:"item.chooseFlag"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }